import DetailsHotelPage from 'components/hotel/Details/DetailsHotelPage';
import MaximizeModal from 'components/shared/MaximizeModal';
import ScreenshotSupport from 'components/shared/ScreenshotSupport';
import useDraggableModal from 'hooks/useDraggableModal';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface DetailsHotelPageModalProps {
  onClose: () => void;
}

const DetailsHotelPageModal: FC<DetailsHotelPageModalProps> = (props) => {
  const { t } = useTranslation();
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const hotelFromSearch = sessionStorage.getItem('hotelFromSearch');
  const hotelFromSearchJson = hotelFromSearch ? JSON.parse(hotelFromSearch) : null;
  return (
    <div className="modal-overlay modal-overlay-top modal-maximizable" ref={modalOverlayRef}>
      <div ref={modalRef} className="modal active" style={modalStyle}>
        <div
          className={'modal-title draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <span className='title'>{t('hotel_info')} - {hotelFromSearchJson?.item?.name}</span>
          <div data-no-drag="true">
            <ScreenshotSupport />
            <MaximizeModal modalOverlayRef={modalOverlayRef} />
            <FontAwesomeIcon icon={faTimes as any} onClick={props.onClose} />
          </div>
        </div>
        <div className="modal-content">
          <DetailsHotelPage />
        </div>
        <div className="modal-footer">
          <button className="btn btn-default" onClick={props.onClose}>
            {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(DetailsHotelPageModal, 'DetailsHotelPageModal');
